import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Principal from './principal';

export default (
  <Route path="principal">
    <IndexRoute component={(props) => <Principal {...props} />} />
  </Route>
);
